import { render, staticRenderFns } from "./PWAprompt.vue?vue&type=template&id=f15216a0&scoped=true&"
import script from "./PWAprompt.vue?vue&type=script&lang=js&"
export * from "./PWAprompt.vue?vue&type=script&lang=js&"
import style0 from "./PWAprompt.vue?vue&type=style&index=0&id=f15216a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15216a0",
  null
  
)

export default component.exports